<template>
  <el-dialog
    class="login-dialog"
    :visible.sync="isShow"
    :append-to-body="true"
    :close-on-click-modal="false"
    :modal="false"
    width="422px">
    <div class="dialog-title">
      <button class="dialog-title-close" @click="setShowDialog(false)">
        <i class="el-icon-close"></i>
      </button>
    </div>
    <div class="dialog-body">
      <div class="loading" v-if="loading"></div>
      <iframe id="iframe" :src="dialogContent[dialogSwitch]" :height="iframeHeight"></iframe>
    </div>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialogContent: [],
      iframeHeight: 400,
      loading:false,
      isShow: false,
      dialogSwitch: 0
    }
  },
  watch:{
    isShow(newVal){
      if(newVal) {
        this.loading = newVal
        setTimeout(()=>{
          const iframe = document.querySelector('#iframe')
          if (iframe.attachEvent) {
            iframe.attachEvent('onload', () => {
              this.loading = false
            })
          } else {
            iframe.onload = () => {
              this.loading = false
            }
          }
        })
      }
    }
  },
  methods: {
    setShowDialog(isShow) {
      this.isShow = isShow
      this.$emit('isShowChange', isShow)
    },
    setDialogSwitch(val) {
      this.dialogSwitch = val
      if (this.dialogSwitch) {
        // 注册点击 神策埋点
        this.$sensors("ClickRegister", {
          current_url: location.href,
          current_title: document.title,
        });
      }
    },
    loginPostMessage(e) {
      let data = e.data;
      if (data.search && ~data.search(/^\{.*\}$/)) {
        try {
          data = JSON.parse(data);
          if (data.type === "modifyDialog") {
            if (data.word === "请登录") {
              this.setDialogSwitch(0);
              this.iframeHeight = 400;
              // is_pop_type = 1;
            } else if (data.word === "注册账号") {
              this.setDialogSwitch(1);
              this.iframeHeight = 400;
              // is_pop_type = 2;
            }
          } else if (data.type === "event") {
            // 注册点击获取验证码事件
            if (data.data && data.data.msg === "regsms" && data.data.mobile) {
              this.$sensors("GetValidationCode", {
                mobile: data.data.mobile + "",
              });
            }
          } else if (data.type === "hqchiplogin") {
            // 登录跳转
            // 判断如果是hqchiplogin 就跳转
            setTimeout(function () {
              window.location.href = data.url;
            }, 1000);
          }
        } catch (e) {
          console.log(e);
        }
      } else if (_.isNumber(_.toNumber(data)) && !_.isNaN(_.toNumber(data))) {
        // 判断类型为数字 控制iframe的高度
        this.iframeHeight = data;
      }
    },
  },
  mounted() {
    const siteid = process.env.VUE_APP_SITEID;
    const ht = process.env.VUE_APP_SSOURL;
    const protocol = location.protocol;
    const hq_source = window.hq_source ? '&hq_source=' + window.hq_source : ''
    const hq_source_link = window.hq_source_link ? '&hq_source_link=' + encodeURIComponent(window.hq_source_link) : '';
    // hqsource referer添加
    let $referer = location.href
    if (hq_source) {
      $referer = decodeURIComponent($referer)
      if ($referer.indexOf('?') > -1) {
          $referer = $referer + ("&hq_source=" + window.hq_source) + ("&hq_source_link=" + encodeURIComponent(window.hq_source_link))
      } else {
          $referer = $referer + ("?hq_source=" + window.hq_source) + ("&hq_source_link=" + encodeURIComponent(window.hq_source_link))
      }
      $referer = encodeURIComponent($referer)
    }
    /** 加载完组件时执行(加载完成之后执行) */
    this.dialogContent = [
      `${protocol}//${ht}/login?fromtype=pop${hq_source}${hq_source_link}&referer=${$referer}&siteid=${siteid}&scene=#${encodeURIComponent(location.href)}`,
      `${protocol}//${ht}/register?fromtype=pop${hq_source}${hq_source_link}&referer=${$referer}&siteid=${siteid}&scene=#${encodeURIComponent(location.href)}`,
    ];
    window.addEventListener("message", this.loginPostMessage, false);
  },
  beforeDestroy() {
    /** 生命周期 - 销毁之前 */
    window.removeEventListener("message", this.loginPostMessage, false);
  },
}
</script>
<style lang="scss" scoped>
.dialog-title {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  height: 20px;
  .dialog-title-close {
    width: 16px;
    height: 16px;
    font-size: 16px;
    outline: 0;
    border: 0;
    background-color: rgba($color: #000000, $alpha: 0);
    color: #999999;
    transform: translate(-10px, 5px);
    &:hover {
      color: #c00;
    }
  }
}
.dialog-body {
  padding: 20px;
  iframe {
    width: 100%;
    // height: 500px;
    border: none;
    transition: all 0.3s;
  }
  .loading {
    background-image: url(~@/assets/common/login/load_ajax.gif);
    width: 30px;
    height: 30px;
    background-repeat: no-repeat;
    background-size: cover;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -15px;
    margin-left: -15px;
  }
}
</style>
<style lang="scss">
.login-dialog .el-dialog {
  outline: 0px;
  background-color: #fff;
  border: 1px solid #c00;
  border-radius: 6px;
  outline: 0;
  font-size: 14px;
  color: #333;
  position: relative;
}
.login-dialog .el-dialog__header {
  display: none;
}
.login-dialog .el-dialog__body {
  padding: 0;
}
</style>